import {
  getCorporationOwner,
  updateCorporationOwner,
  getUsers,
} from "../../../../../../api/configuration";
import { useSavedForm, SaveFooter, LoadState } from "./savedForm";
const read = async () => {
  const response = await getCorporationOwner();
  const owner = response?.data?.owners?.[0];
  if (
    response?.error !== false ||
    !owner ||
    typeof owner !== "object" ||
    Array.isArray(owner)
  )
    throw new Error();
  return {
    raw: owner,
    draft: Object.fromEntries(
      ["fullname", "nif", "email", "phone"].map((key) => [
        key,
        owner[key] || "",
      ]),
    ),
  };
};
const write = async (draft, raw) => {
  const response = await getUsers();
  const owners = response?.data?.owners;
  if (response?.error !== false || !Array.isArray(owners)) throw new Error();
  const matches = owners.filter(
    (owner) =>
      owner.email &&
      raw.email &&
      owner.email.toLowerCase() === raw.email.toLowerCase(),
  );
  if (matches.length !== 1 || !matches[0].userId) throw new Error();
  return updateCorporationOwner(matches[0].userId, draft);
};
export const OwnerInformation = () => {
  const form = useSavedForm(read, write);
  if (!form.record)
    return <LoadState form={form} label="datos del propietario" />;
  return (
    <form
      className="generalReferenceForm"
      onSubmit={form.save}
      aria-busy={form.saving}
    >
      <fieldset disabled={form.saving}>
        <legend className="visually-hidden">Información del propietario</legend>
        <div className="generalFormBody ownerFields">
          {[
            ["fullname", "Nombre del propietario", "ownerNameInput"],
            ["nif", "DNI", "DNIInput"],
            ["email", "Correo electrónico", "ownermailInput"],
            ["phone", "Teléfono de contacto", "ownerPhoneInput"],
          ].map(([key, label, id]) => (
            <label key={key} htmlFor={id}>
              {label}
              <input
                id={id}
                type={
                  key === "email" ? "email" : key === "phone" ? "tel" : "text"
                }
                value={form.draft[key]}
                onChange={(e) =>
                  form.setDraft((previous) => ({
                    ...previous,
                    [key]: e.target.value,
                  }))
                }
              />
            </label>
          ))}
        </div>
        <SaveFooter {...form} />
      </fieldset>
    </form>
  );
};
